// Game-specific translations
export const gameTranslations = {
  en: {
    // Spot The Sign Game
    spotTheSign: {
      title: 'Spot The Sign',
      subtitle: 'Find unusual changes in breast images to become an Eagle Eye Detective!',
      chooseChallenge: 'Choose Your Challenge',
      easy: 'Easy',
      medium: 'Medium',
      hard: 'Hard',
      easyDesc: 'Perfect for beginners - larger signs, more time',
      mediumDesc: 'Moderate challenge - smaller signs, less time',
      hardDesc: 'Expert level - tiny signs, minimal time',
      signsToFind: 'Signs to find',
      timeLimit: 'Time limit',
      multiplier: 'Multiplier',
      howToPlay: 'How to Play',
      objective: 'Objective',
      objectiveDesc: 'Find all the unusual signs in the breast image before time runs out!',
      scoring: 'Scoring',
      correctSpot: 'Correct spot',
      timeBonus: 'Time bonus',
      wrongClick: 'Wrong click',
      signsToLookFor: 'Signs to Look For',
      found: 'Found',
      progress: 'Progress',
      finalScore: 'Final Score',
      signsFound: 'Signs Found',
      accuracy: 'Accuracy',
      badgeEarned: 'Badge Earned!',
      eagleEyeDetective: 'Eagle Eye Detective',
      eagleEyeDesc: "You've mastered the art of spotting breast health signs!",
      excellent: 'Excellent!',
      greatJob: 'Great Job!',
      goodEffort: 'Good Effort!',
      keepPracticing: 'Keep Practicing!',
      generatingGame: 'Generating Game...',
      timerPaused: 'Timer Paused',
      keySymptoms: 'Key Symptoms',
      saveInfo: 'Save Info',
      autoCloseMsg: 'Dialog will auto-close in 10 seconds, or click Continue Game',
      
      // Sign types
      lump: 'Lump/Mass',
      lumpDesc: 'A hard, painless lump or thickening in the breast tissue',
      dimpling: 'Skin Dimpling',
      dimplingDesc: 'Puckering or dimpling of the breast skin, like an orange peel',
      nippleInversion: 'Nipple Changes',
      nippleInversionDesc: 'Sudden inversion or retraction of the nipple',
      redness: 'Skin Redness',
      rednessDesc: 'Unusual redness, warmth, or rash on breast skin',
      discharge: 'Nipple Discharge',
      dischargeDesc: 'Unusual discharge from the nipple, especially if bloody',
      sizeChange: 'Size/Shape Change',
      sizeChangeDesc: 'Noticeable change in breast size or shape',
      lymphNodes: 'Swollen Lymph Nodes',
      lymphNodesDesc: 'Swollen lymph nodes under the arm or near the collarbone',
    },
    
    // Myth vs Fact Game
    mythVsFact: {
      title: 'Myth vs Fact',
      subtitle: 'Bust myths with rapid-fire quiz and become a Myth Buster!',
      gameRules: 'Game Rules',
      howToPlay: 'How to Play',
      scoringSystem: 'Scoring System',
      questionCategories: 'Question Categories',
      questionsFromPool: 'questions from pool of 30',
      mixOfMyths: 'Mix of myths and facts',
      secondsPerQuestion: 'seconds per question',
      buildStreaks: 'Build streaks for bonus points',
      differentQuestions: 'Different questions each game!',
      basePoints: 'Base: 10 points per correct answer',
      timeBonusDesc: 'Time bonus: +50% if answered in 10s',
      streakBonus: 'Streak bonus: +10% per consecutive correct',
      perfectScore: 'Perfect score: 200+ points',
      myth: 'MYTH',
      fact: 'FACT',
      mythDesc: 'This statement is FALSE',
      factDesc: 'This statement is TRUE',
      correct: 'Correct!',
      incorrect: 'Incorrect!',
      streak: 'streak!',
      mythBusterBadge: 'Myth Buster',
      mythBusterDesc: "You've mastered breast health facts and busted the myths!",
      finalScore: 'Final Score',
      correctAnswers: 'Correct',
      bestStreak: 'Best Streak',
      
      // Categories
      symptoms: 'Symptoms',
      screening: 'Screening',
      treatment: 'Treatment',
      lifestyle: 'Lifestyle',
      prevention: 'Prevention',
      genetics: 'Genetics',
      ageRisk: 'Age & Risk',
      gender: 'Gender',
      statistics: 'Statistics',
    }
  },
  
  hi: {
    // Spot The Sign Game
    spotTheSign: {
      title: 'संकेत खोजें',
      subtitle: 'ईगल आई डिटेक्टिव बनने के लिए स्तन छवियों में असामान्य परिवर्तन खोजें!',
      chooseChallenge: 'अपनी चुनौती चुनें',
      easy: 'आसान',
      medium: 'मध्यम',
      hard: 'कठिन',
      easyDesc: 'शुरुआती लोगों के लिए बिल्कुल सही - बड़े संकेत, अधिक समय',
      mediumDesc: 'मध्यम चुनौती - छोटे संकेत, कम समय',
      hardDesc: 'विशेषज्ञ स्तर - छोटे संकेत, न्यूनतम समय',
      signsToFind: 'खोजने के लिए संकेत',
      timeLimit: 'समय सीमा',
      multiplier: 'गुणक',
      howToPlay: 'कैसे खेलें',
      objective: 'उद्देश्य',
      objectiveDesc: 'समय समाप्त होने से पहले स्तन छवि में सभी असामान्य संकेत खोजें!',
      scoring: 'स्कोरिंग',
      correctSpot: 'सही स्थान',
      timeBonus: 'समय बोनस',
      wrongClick: 'गलत क्लिक',
      signsToLookFor: 'देखने के लिए संकेत',
      found: 'मिला',
      progress: 'प्रगति',
      finalScore: 'अंतिम स्कोर',
      signsFound: 'संकेत मिले',
      accuracy: 'सटीकता',
      badgeEarned: 'बैज अर्जित किया!',
      eagleEyeDetective: 'ईगल आई डिटेक्टिव',
      eagleEyeDesc: 'आपने स्तन स्वास्थ्य संकेतों को खोजने की कला में महारत हासिल कर ली है!',
      excellent: 'उत्कृष्ट!',
      greatJob: 'बढ़िया काम!',
      goodEffort: 'अच्छा प्रयास!',
      keepPracticing: 'अभ्यास जारी रखें!',
      generatingGame: 'खेल तैयार हो रहा है...',
      timerPaused: 'टाइमर रुका हुआ',
      keySymptoms: 'मुख्य लक्षण',
      saveInfo: 'जानकारी सहेजें',
      autoCloseMsg: 'डायलॉग 10 सेकंड में स्वतः बंद हो जाएगा, या खेल जारी रखें पर क्लिक करें',
      
      // Sign types
      lump: 'गांठ/द्रव्यमान',
      lumpDesc: 'स्तन ऊतक में एक कठोर, दर्द रहित गांठ या मोटाई',
      dimpling: 'त्वचा में गड्ढे',
      dimplingDesc: 'स्तन की त्वचा में झुर्रियां या गड्ढे, संतरे के छिलके की तरह',
      nippleInversion: 'निप्पल में परिवर्तन',
      nippleInversionDesc: 'निप्पल का अचानक अंदर की ओर मुड़ना या पीछे हटना',
      redness: 'त्वचा की लालिमा',
      rednessDesc: 'स्तन की त्वचा पर असामान्य लालिमा, गर्मी, या दाने',
      discharge: 'निप्पल स्राव',
      dischargeDesc: 'निप्पल से असामान्य स्राव, विशेष रूप से यदि खूनी हो',
      sizeChange: 'आकार/रूप में परिवर्तन',
      sizeChangeDesc: 'स्तन के आकार या रूप में ध्यान देने योग्य परिवर्तन',
      lymphNodes: 'सूजी हुई लसीका ग्रंथियां',
      lymphNodesDesc: 'बांह के नीचे या कॉलरबोन के पास सूजी हुई लसीका ग्रंथियां',
    },
    
    // Myth vs Fact Game
    mythVsFact: {
      title: 'मिथक बनाम तथ्य',
      subtitle: 'तेज़ क्विज़ के साथ मिथकों को तोड़ें और मिथक बस्टर बनें!',
      gameRules: 'खेल के नियम',
      howToPlay: 'कैसे खेलें',
      scoringSystem: 'स्कोरिंग प्रणाली',
      questionCategories: 'प्रश्न श्रेणियां',
      questionsFromPool: '30 में से प्रश्न',
      mixOfMyths: 'मिथकों और तथ्यों का मिश्रण',
      secondsPerQuestion: 'प्रति प्रश्न सेकंड',
      buildStreaks: 'बोनस अंकों के लिए लकीरें बनाएं',
      differentQuestions: 'हर खेल में अलग प्रश्न!',
      basePoints: 'आधार: प्रति सही उत्तर 10 अंक',
      timeBonusDesc: 'समय बोनस: 10 सेकंड में उत्तर देने पर +50%',
      streakBonus: 'लकीर बोनस: प्रति लगातार सही +10%',
      perfectScore: 'परफेक्ट स्कोर: 200+ अंक',
      myth: 'मिथक',
      fact: 'तथ्य',
      mythDesc: 'यह कथन गलत है',
      factDesc: 'यह कथन सही है',
      correct: 'सही!',
      incorrect: 'गलत!',
      streak: 'लकीर!',
      mythBusterBadge: 'मिथक बस्टर',
      mythBusterDesc: 'आपने स्तन स्वास्थ्य तथ्यों में महारत हासिल कर ली है और मिथकों को तोड़ दिया है!',
      finalScore: 'अंतिम स्कोर',
      correctAnswers: 'सही',
      bestStreak: 'सर्वश्रेष्ठ लकीर',
      
      // Categories
      symptoms: 'लक्षण',
      screening: 'जांच',
      treatment: 'उपचार',
      lifestyle: 'जीवनशैली',
      prevention: 'रोकथाम',
      genetics: 'आनुवंशिकी',
      ageRisk: 'आयु और जोखिम',
      gender: 'लिंग',
      statistics: 'आंकड़े',
    }
  }
};
